/**
 * Custom Megamenu - GIGAPRINT
 * Sistema multi-layout con posicionamiento dinámico
 *
 * Debug: agregar ?megamenu=debug a la URL para mantener los megamenus abiertos
 *        ?megamenu=debug&megamenu-handle=nombre para abrir uno específico
 */

(function() {
  'use strict';

  // Configuración
  var CONFIG = {
    DESKTOP_BREAKPOINT: 1024,
    ANIMATION_DURATION: 300,
    HOVER_DELAY: 150
  };

  // Selectores
  var SELECTORS = {
    navItem: '.site-nav__item[data-megamenu-handle]',
    megamenu: '.custom-megamenu[data-megamenu-for]',
    closeBtn: '[data-megamenu-close]',
    overlay: '.custom-megamenu__overlay',
    column: '[data-mm-column]'
  };

  // Estado
  var state = {
    activeMegamenu: null,
    hoverTimeout: null,
    isTouch: false,
    lastTrigger: null,
    debug: false
  };

  /**
   * Detecta modo debug via URL param: ?megamenu=debug
   */
  function detectDebugMode() {
    var params = new URLSearchParams(window.location.search);
    state.debug = params.get('megamenu') === 'debug';
    return state.debug;
  }

  /**
   * Activa el modo debug - fuerza megamenus visibles
   */
  function activateDebugMode() {
    var targetHandle = new URLSearchParams(window.location.search).get('megamenu-handle');
    var megamenus = document.querySelectorAll(SELECTORS.megamenu);

    megamenus.forEach(function(mm) {
      // Si hay un handle específico, solo abrir ese
      if (targetHandle && mm.dataset.megamenuFor !== targetHandle) return;

      mm.classList.add('custom-megamenu--debug', 'is-active');
      var navItem = mm.closest(SELECTORS.navItem);
      if (navItem) navItem.classList.add('custom-megamenu-open');
    });

    console.log(
      '%c[Megamenu DEBUG] %cModo debug activo — los megamenus no se cerrarán',
      'color: #2563eb; font-weight: bold;',
      'color: #475569;'
    );

    if (targetHandle) {
      console.log('[Megamenu DEBUG] Filtrado por handle:', targetHandle);
    }

    // Log info de cada megamenu
    megamenus.forEach(function(mm) {
      var handle = mm.dataset.megamenuFor;
      var layout = mm.dataset.megamenuLayout;
      var cols = mm.style.getPropertyValue('--megamenu-columns');
      var containerW = mm.querySelector('.custom-megamenu__container');
      var colsWrapper = mm.querySelector('.custom-megamenu__columns-wrapper');
      console.log(
        '[Megamenu DEBUG] "' + handle + '" → layout: ' + layout +
        ', cols: ' + (cols || 'default(4)') +
        ', container: ' + (containerW ? containerW.offsetWidth + 'px' : 'N/A') +
        ', grid: ' + (colsWrapper ? colsWrapper.offsetWidth + 'px' : 'N/A')
      );
    });
  }

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function setActiveColumn(megamenu, targetId) {
    if (!megamenu) return;

    var columns = megamenu.querySelectorAll(SELECTORS.column);
    var hasTarget = false;

    columns.forEach(function(column) {
      var isTarget = targetId && column.id === targetId;
      column.classList.toggle('is-active', !!isTarget);
      if (isTarget) hasTarget = true;
    });

    if (!hasTarget && columns.length > 0) {
      columns[0].classList.add('is-active');
    }
  }

  /**
   * Detecta si es dispositivo táctil
   */
  function detectTouch() {
    state.isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  }

  /**
   * Verifica si es desktop
   */
  function isDesktop() {
    return window.innerWidth >= CONFIG.DESKTOP_BREAKPOINT;
  }

  /**
   * Obtiene todos los nav items con megamenu
   */
  function getNavItems() {
    return document.querySelectorAll(SELECTORS.navItem);
  }

  /**
   * Obtiene el megamenu de un nav item
   */
  function getMegamenu(navItem) {
    return navItem.querySelector(SELECTORS.megamenu);
  }

  /**
   * Calcula y ajusta la posición del megamenu para evitar cortes
   */
  function positionMegamenu(megamenu, trigger) {
    var layout = megamenu.dataset.megamenuLayout || 'full-width';

    // Solo ajustar posición para layout dropdown
    if (layout === 'dropdown') {
      var triggerRect = trigger.getBoundingClientRect();
      var megamenuWidth = megamenu.offsetWidth;
      var viewportWidth = window.innerWidth;
      var padding = 20;

      // Resetear estilos de posición
      megamenu.style.left = '';
      megamenu.style.right = '';
      megamenu.classList.remove('is-aligned-right');

      // Si se sale por la derecha, alinear a la derecha
      if (triggerRect.left + megamenuWidth + padding > viewportWidth) {
        megamenu.classList.add('is-aligned-right');
      }
    }

    // Para centered, verificar que no se corte
    if (layout === 'centered') {
      var containerWidth = Math.min(
        parseInt(megamenu.style.getPropertyValue('--megamenu-max-width')) || 1400,
        viewportWidth - 40
      );
      megamenu.style.width = containerWidth + 'px';
    }
  }

  /**
   * Abre un megamenu
   */
  function openMegamenu(navItem, megamenu) {
    // Cerrar cualquier otro megamenu abierto
    if (state.activeMegamenu && state.activeMegamenu !== megamenu) {
      closeMegamenu(state.activeMegamenu.closest(SELECTORS.navItem), state.activeMegamenu, true);
    }

    // Calcular posición
    positionMegamenu(megamenu, navItem);

    // Activar
    navItem.classList.add('custom-megamenu-open');
    megamenu.classList.add('is-active');
    navItem.setAttribute('data-megamenu-state', 'open');
    megamenu.setAttribute('data-state', 'open');
    state.activeMegamenu = megamenu;

    // Accesibilidad
    var link = navItem.querySelector('.site-nav__link');
    if (link) {
      link.setAttribute('aria-expanded', 'true');
      state.lastTrigger = link;
    }

    // Bloquear scroll para sidebars
    var layout = megamenu.dataset.megamenuLayout;
    if (layout === 'sidebar-left' || layout === 'sidebar-right') {
      document.body.style.overflow = 'hidden';
      var focusableElements = getFocusableElements(megamenu);
      if (focusableElements.length > 0) {
        setTimeout(function() {
          focusableElements[0].focus();
        }, 40);
      }
    }

    setActiveColumn(megamenu);
  }

  /**
   * Cierra un megamenu
   */
  function closeMegamenu(navItem, megamenu, immediate) {
    if (!megamenu) return;

    // En debug mode, no cerrar
    if (state.debug && megamenu.classList.contains('custom-megamenu--debug')) return;

    navItem.classList.remove('custom-megamenu-open');
    megamenu.classList.remove('is-active');
    navItem.setAttribute('data-megamenu-state', 'closed');
    megamenu.setAttribute('data-state', 'closed');

    if (state.activeMegamenu === megamenu) {
      state.activeMegamenu = null;
    }

    // Accesibilidad
    var link = navItem.querySelector('.site-nav__link');
    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }

    // Restaurar scroll
    document.body.style.overflow = '';
    setActiveColumn(megamenu);

    // Animación de salida (el CSS maneja la transición)
    var layout = megamenu.dataset.megamenuLayout || 'full-width';
    var shouldRestoreFocus = (layout === 'sidebar-left' || layout === 'sidebar-right') || megamenu.contains(document.activeElement);
    if (shouldRestoreFocus && state.lastTrigger && typeof state.lastTrigger.focus === 'function') {
      state.lastTrigger.focus();
    }
  }

  /**
   * Cierra todos los megamenus
   */
  function closeAllMegamenus() {
    getNavItems().forEach(function(navItem) {
      var megamenu = getMegamenu(navItem);
      if (megamenu) {
        closeMegamenu(navItem, megamenu);
      }
    });
  }

  /**
   * Inicializa eventos de hover para desktop
   */
  function initHoverEvents(navItem, megamenu) {
    var layout = megamenu.dataset.megamenuLayout || 'full-width';

    // Sidebars no usan hover, solo click
    if (layout === 'sidebar-left' || layout === 'sidebar-right') {
      return;
    }

    // Mouse enter en nav item
    navItem.addEventListener('mouseenter', function() {
      if (!isDesktop() || state.isTouch) return;

      clearTimeout(state.hoverTimeout);
      state.hoverTimeout = setTimeout(function() {
        openMegamenu(navItem, megamenu);
      }, CONFIG.HOVER_DELAY);
    });

    // Mouse leave de nav item
    navItem.addEventListener('mouseleave', function(e) {
      if (!isDesktop() || state.isTouch) return;
      if (state.debug) return;

      clearTimeout(state.hoverTimeout);

      // Verificar si el mouse va hacia el megamenu
      var rect = megamenu.getBoundingClientRect();
      var goingToMegamenu = e.clientY >= rect.top - 20 &&
                           e.clientX >= rect.left &&
                           e.clientX <= rect.right;

      if (!goingToMegamenu) {
        state.hoverTimeout = setTimeout(function() {
          closeMegamenu(navItem, megamenu);
        }, CONFIG.HOVER_DELAY);
      }
    });

    // Mouse enter en megamenu
    megamenu.addEventListener('mouseenter', function() {
      if (!isDesktop() || state.isTouch) return;
      clearTimeout(state.hoverTimeout);
    });

    // Mouse leave de megamenu
    megamenu.addEventListener('mouseleave', function() {
      if (!isDesktop() || state.isTouch) return;
      if (state.debug) return;

      state.hoverTimeout = setTimeout(function() {
        closeMegamenu(navItem, megamenu);
      }, CONFIG.HOVER_DELAY);
    });
  }

  /**
   * Inicializa eventos de click/tap
   */
  function initClickEvents(navItem, megamenu) {
    var link = navItem.querySelector('.site-nav__link');
    var layout = megamenu.dataset.megamenuLayout || 'full-width';

    // Click en el link del nav
    if (link) {
      link.addEventListener('click', function(e) {
        // En mobile o para sidebars, siempre toggle
        if (!isDesktop() || layout === 'sidebar-left' || layout === 'sidebar-right') {
          e.preventDefault();
          e.stopPropagation();

          var isOpen = navItem.classList.contains('custom-megamenu-open');
          if (isOpen) {
            closeMegamenu(navItem, megamenu);
          } else {
            openMegamenu(navItem, megamenu);
          }
        }
        // En desktop con touch, primer tap abre, segundo navega
        else if (state.isTouch) {
          if (!navItem.classList.contains('custom-megamenu-open')) {
            e.preventDefault();
            openMegamenu(navItem, megamenu);
          }
        }
      });
    }

    // Botones de cerrar (para sidebars)
    var closeButtons = megamenu.querySelectorAll(SELECTORS.closeBtn);
    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMegamenu(navItem, megamenu);
      });
    });

  }

  /**
   * Inicializa eventos globales
   */
  function initGlobalEvents() {
    // Click fuera cierra megamenu
    document.addEventListener('click', function(e) {
      if (!state.activeMegamenu) return;
      if (state.debug) return;

      var clickedNavItem = e.target.closest(SELECTORS.navItem);
      var clickedMegamenu = e.target.closest(SELECTORS.megamenu);

      if (!clickedNavItem && !clickedMegamenu) {
        closeAllMegamenus();
      }
    });

    // Tecla Escape cierra megamenu
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.activeMegamenu) {
        if (state.debug) return;
        closeAllMegamenus();
      }
    });

    // Tab navigation - focus trap para sidebars
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab' || !state.activeMegamenu) return;

      var layout = state.activeMegamenu.dataset.megamenuLayout;
      if (layout !== 'sidebar-left' && layout !== 'sidebar-right') return;

      var focusableElements = getFocusableElements(state.activeMegamenu);

      if (focusableElements.length === 0) return;

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    });

    // Resize - recalcular posiciones
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (state.activeMegamenu) {
          var navItem = state.activeMegamenu.closest(SELECTORS.navItem);
          positionMegamenu(state.activeMegamenu, navItem);
        }
      }, 100);
    });
  }

  /**
   * Inicialización principal
   */
  function init() {
    detectTouch();
    var isDebug = detectDebugMode();

    var navItems = getNavItems();

    navItems.forEach(function(navItem) {
      var megamenu = getMegamenu(navItem);
      if (!megamenu) return;

      initHoverEvents(navItem, megamenu);
      initClickEvents(navItem, megamenu);
    });

    initGlobalEvents();

    // Activar debug si el param está presente
    if (isDebug) {
      activateDebugMode();
    }

    // Debug info en desarrollo
    if (window.location.hostname === 'localhost' || window.location.hostname.includes('myshopify')) {
      console.log('[Megamenu] Inicializado con', navItems.length, 'items' + (isDebug ? ' (DEBUG MODE)' : ''));
    }
  }

  // Iniciar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Exponer API pública para debugging
  window.GigaprintMegamenu = {
    open: function(handle) {
      var navItem = document.querySelector('[data-megamenu-handle="' + handle + '"]');
      if (navItem) {
        var megamenu = getMegamenu(navItem);
        if (megamenu) openMegamenu(navItem, megamenu);
      }
    },
    close: closeAllMegamenus,
    debug: function(enable) {
      state.debug = enable !== false;
      if (state.debug) {
        activateDebugMode();
        console.log('[Megamenu] Debug activado via API');
      } else {
        document.querySelectorAll('.custom-megamenu--debug').forEach(function(mm) {
          mm.classList.remove('custom-megamenu--debug');
        });
        closeAllMegamenus();
        console.log('[Megamenu] Debug desactivado');
      }
    },
    getState: function() { return state; }
  };

})();
